define((require) => {
    "use strict";

    var Action              = require("editor/util/Action"),
        Permissions         = require("shared/security/Permissions"),
        MsSharedEntityModel = require("ui/experienceOverview/experiencePermissions/MsSharedEntityModel"),
        SharedEntityType    = require("ui/experienceOverview/experiencePermissions/SharedEntityType"),
        ProjectAsset        = require("ui/editor/project/ProjectAsset"),
        LoggedInUserState   = require("shared/ui/user/LoggedInUserState"),
        PublishableState    = require("util/PublishableState");

    /**
     * Action that will duplicate the permission data associated with a group or experience
     *
     * @class DuplicateExperiencePermissionsAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} previousModel The previous experience model
         * @param  {ExperienceModel} clone The cloned experience model
         */
        constructor: function(previousModel, clone) {
            this.__super();

            this._previousModel = previousModel;
            this._cloneModel = clone;
        },

        executable: function() {
            const canCreatePushPublishExperience = Permissions.Privileges.CREATE.can()
                && (!this._previousModel.hasAtLeastState(PublishableState.PUSHED)
                || Permissions.Privileges.PUBLISH.can());
            const isPermissioningEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");
            return canCreatePushPublishExperience && isPermissioningEnabled;
        },

        _performExecution: function() {
            const previousModel = this._previousModel;

            let sharedEntityType;
            if (previousModel.get("type") === ProjectAsset.Type.EXPERIENCE) {
                sharedEntityType = SharedEntityType.EXPERIENCE;
            } else if (previousModel.get("type") === ProjectAsset.Type.BREAKPOINTGROUP ||
                previousModel.get("type") === ProjectAsset.Type.LOCALIZATIONGROUP) {
                sharedEntityType = SharedEntityType.GROUP;
            } else {
                // If it's not a group and experience do not copy
                return;
            }

            let sharedEntity = new MsSharedEntityModel({
                entityId: previousModel.get("id"),
                entityType: sharedEntityType
            });

            return sharedEntity.fetch()
                .then((sharedEntityResponse) => {
                    this._duplicateAndSaveSharedEntity(sharedEntityResponse);
                });
        },

        _duplicateAndSaveSharedEntity(sharedEntity) {
            const clone = sharedEntity.clone({duplicate: true});
            clone.set("entityId", this._cloneModel.get("id"));

            return clone.save({}, {url: clone.postURL()}).then(() => {
                return clone;
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/DuplicateExperiencePermissionsAction.js